const en_master_user = {
    "": "user",
    add: "add user",
    edit: "edit user",

    label: {
        warehouse_all: "select all warehouses",
        user_confirm: "approval user",
        price_change: "change price",
    },

    error: {
        warehouse: "At least 1 warehouse is required.",
        profile: "Profile cannot be empty.",
        create: "Failed to create user.",
        edit: "Failed to update user.",
    },

    success: {
        create: "User created successfully.",
        edit: "User updated successfully.",
    },
}

export default en_master_user;